var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scrollable-block"},[_c('div',{staticClass:"main-block request-management"},[_c('Breadcrumbs'),_c('SystemStatistics')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }